import { render, staticRenderFns } from "./MerchantBalance.vue?vue&type=template&id=950f8532&"
import script from "./MerchantBalance.vue?vue&type=script&lang=js&"
export * from "./MerchantBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports